import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";
import type { TicketCargoSummary } from "../../models/Ticket";
import { formatTicketCargoAddress } from "../../utils/ticket";

interface CommunicationCargoSummaryProps {
  cargo?: TicketCargoSummary | null;
  variant?: "compact" | "detail";
}

const CommunicationCargoSummary: React.FC<CommunicationCargoSummaryProps> = ({
  cargo,
  variant = "compact",
}) => {
  if (!cargo) {
    return null;
  }

  const imageSize = variant === "detail" ? 96 : 72;
  const title = cargo.name || "关联货源";
  const fromLabel = formatTicketCargoAddress(cargo.from);
  const toLabel = formatTicketCargoAddress(cargo.to);

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        borderRadius: 1.5,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.default",
        p: 1.25,
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="flex-start">
        <Box
          sx={{
            width: imageSize,
            height: imageSize,
            flexShrink: 0,
            borderRadius: 1.25,
            overflow: "hidden",
            bgcolor: "grey.100",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {cargo.image ? (
            <Box
              component="img"
              src={cargo.image}
              alt={title}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Typography variant="caption" color="text.secondary">
              暂无图片
            </Typography>
          )}
        </Box>

        <Stack spacing={0.5} sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="caption" color="text.secondary">
            关联货源{cargo.id ? ` · ${cargo.id}` : ""}
          </Typography>
          <Typography
            variant="body2"
            fontWeight={600}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: variant === "detail" ? 2 : 1,
              WebkitBoxOrient: "vertical",
              wordBreak: "break-all",
            }}
          >
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            发货地：{fromLabel}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            收货地：{toLabel}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CommunicationCargoSummary;
